/**
 * ExamEnrollment scene sagas
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */

import { takeLatest, put } from 'redux-saga/effects';
import { actions } from 'store/rootSlices';

function* onMountSaga() {
  yield put(actions.ExamsTest.setLoading(false));
}

function* onUnmountSaga() {}

export default function* watcherSignin() {
  yield takeLatest('ExamsTest/onMount', onMountSaga);
  yield takeLatest('ExamsTest/onUnmount', onUnmountSaga);
}
